<template>
  <item title="项目经历">
    <sub-item title="维普职考在线" sub-title="flutter-app & nuxt-web 开发" company="维普朗润">
      <div>
        <p>维普职考在线是一个集在线学习、考试系统于一体的在线学习平台，官网链接：<a href="https://xuexi.cqvip.com/">xuexi.cqvip.com</a></p>
        技术点：
        <p>
          1. APP中群聊功能集成极光IM，但是 SDK 中有部分 bug，因此自学了 Objective-C 进行修复。同时自己新增了清空聊天记录 API。
        </p>
        <p>
          2. APP以及WEB端的考试系统的试题以及选项包含 html 富文本，在 APP 端采用 flutter_html 进行封装渲染，WEB 端使用 vue-dompurify-html 渲染避免 XSS 攻击。
        </p>
        <p>
          3. 考试系统中的防作弊功能支持切屏监测、长时间无操作监测。切屏监测通过监听 app  的生命周期、网页的焦点事件完成。长时间无操作则通过监听底层指针事件完成。
        </p>
        <p>
          4. APP的卡片堆叠效果，通过继承 MultiChildRenderObjectWidget 调整绘制顺序完成效果。
        </p>
      </div>
    </sub-item>
    <sub-item title="微图" sub-title="flutter-app 研发维护" company="上海精灵天下重庆分公司">
      <div>
        <p>
          微图app是一个主打图片出售的app，用户可以上传图片素材，然后将素材制作成图片、图集、图文、影集。随后可以申请认证为摄影师，上架图片以供出售。<br>
        </p>
        技术点：
        <p>
          1. 项目中使用 webview 显示网页并且 js 需要调用 flutter App 中的函数，但是 flutter App 无法直接返回执行结果。
          于是我在网页端封装了一个 callFlutter 函数，调用该函数时返回一个 Promise 对象，当 flutter App 执行完后执行
          resolve 并传入返回结果即可。
        </p>
        <p>
          2. 首页的 TabBar+TabView 切换效果有个效果是当前选择的 TabBar 字体大一点，未选择的小一点，且在左右滑动时字体大小改变。
          最开始直接根据滑动位置设置字体大小，但是动画效果会抖动。不过换个思考方向，可以对整个 Tab Widget 进行缩放，于是该问题圆满解决。
        </p>
      </div>
    </sub-item>

    <sub-item title="蜂巢热点" sub-title="flutter-app & h5 研发维护" company="上海精灵天下重庆分公司">
      <div>
        <p>
          热点是一个聚合实时热点要闻的聚合类资讯APP，我负责 App 及 h5 分享页的开发。
        </p>
        技术点：
        <p>
          1. 我发现 h5 页面效果更新频率较高，于是学习使用 gitlab CI\CD 进行自动编译部署，
          利用 gitlab-runner 执行 npm run build & cp 以解决手动打包上传效率低下问题。并推广到其他项目解放双手。
        </p>
        <p>
          2. 使用模板方法模式设计一个抽象 BasePage 类解决页面跳转回退代码多的问题，将 4 行页面打开代码缩减至 1 行代码，
          并且能为页面提供常用方法。
        </p>
      </div>
    </sub-item>
    <sub-item title="蜂集市WEB后台管理" sub-title="web前端研发维护" company="重庆蜂效科技集团有限公司">
      <div>
        <p>
          后台管理集成商户系统、财务系统、超级管理员系统。根据超级管理员分配的角色权限来访问对应的功能。
        </p>
        技术点：
        <p>
          1. 使用 js 监听页面滚动并计算目标元素的 offsetTop 来实现内容导航联动。以实现滚动设置项时，点亮对应的导航类目。
        </p>
        <p>
          2. 如何实现根据不同权限显示对应的功能菜单？经过和后端同学的沟通，决定由后端接口返回当前用户可以访问的路由，
          前端初始的 router 对象只有 404，login 等基础页面。将功能路由写到另外一个列表中，根据后端返回的路由列表进行递归匹配，
          筛选出可访问的 Routers，再根据 routers 来渲染菜单栏。
        </p>
      </div>
    </sub-item>
  </item>
</template>

<script>
import Item from './Item'
import SubItem from './SubItem'

export default {
  name: 'ProjectHistory',
  components: {
    SubItem,
    Item
  }
}
</script>

<style scoped lang="less">
@import "../common";
</style>
